<template>
  <div class="full-height">
    <no-auth v-if="!userInfo.agencyCode"></no-auth>
    <div v-else class="coupon-category-app-container" style="position: relative; height: 100%">
      <el-dialog
        v-loading="dialogLoading"
        :top="dialogTopMargin"
        :title="funcName + '維護'"
        :visible.sync="dialogVisible"
        width="50%"
      >
        <el-card class="box-card">
          <el-form ref="form" :model="form" :label-width="formLabelWidth">
            <el-form-item :label="funcName + '名稱'">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-form>
        </el-card>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">確 定</el-button>
        </span>
      </el-dialog>

      <!-- <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item label="查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入團號/團名" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getAgencyTravelsAndOtherInformation"
            >查詢</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-button
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh"
          ></el-button>
        </el-form-item>
      </el-form>
    </div> -->

      <el-form :inline="true" class="filter-form" @submit.native.prevent>
        <el-form-item label="查詢">
          <el-input
            v-model="listQuery.qry"
            placeholder="輸入團號/團名"
            @keyup.enter.native="getAgencyTravelsAndOtherInformation"
          />
        </el-form-item>

        <el-button
          type="primary"
          @click="getAgencyTravelsAndOtherInformation"
          icon="el-icon-search"
          circle
          style="margin-top: 8px; margin-left: 5px"
          :disabled="listLoading"
        ></el-button>
        <el-button
          style="cursor: pointer"
          type="success"
          :loading="listLoading"
          circle
          icon="el-icon-refresh-left"
          @click="refresh()"
        ></el-button>
      </el-form>

      <div style="position: relative; height: 80%">
        <el-table
          ref="formDetailsTable"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          style="width: 100%"
          height="100%"
        >
          <el-table-column align="center" label="數量" width="1" type="expand">
            <template slot-scope="scope">
              <el-table
                size="mini"
                :data="scope.row.travelResultCommonForms"
                border
                style="width: 100%"
                height="200"
                :row-class-name="tableRowClassName"
              >
                <el-table-column align="center" label="項次" width="50">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                    <!-- <el-tag size="mini" type="success">{{
                    scope.$index + 1
                  }}</el-tag> -->
                  </template>
                </el-table-column>

                <el-table-column align="center" label="回傳者" width="200">
                  <template slot-scope="scope">
                    <span v-if="scope.row.formFile && scope.row.formFile.leaderInfo">
                      {{ scope.row.formFile.leaderInfo.name }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="旅客名稱" width="200">
                  <template slot-scope="scope">
                    <span v-if="scope.row.formFile && scope.row.formFile.travelerInfo">
                      <span
                        v-for="(travelerItem, travelerItemIndex) in scope.row.formFile.travelerInfo
                          .name"
                        :key="`${travelerItemIndex}_${travelerItem}`"
                      >
                        {{ travelerItem }}
                        <span
                          v-show="
                            travelerItemIndex != scope.row.formFile.travelerInfo.name.length - 1
                          "
                          >、</span
                        >
                      </span>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="描述" width="200">
                  <template slot-scope="scope">
                    {{ scope.row.formDesc }}
                  </template>
                </el-table-column>

                <el-table-column align="center" label="檔案名稱">
                  <template slot-scope="scope">
                    <span v-if="scope.row.formFile && scope.row.formFile.fileInfo">
                      {{ scope.row.formFile.fileInfo.fileRealName }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="下載" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.formFile && scope.row.formFile.fileInfo">
                      <el-button
                        size="mini"
                        type="info"
                        @click="
                          downloadFile(
                            scope.row.formFile.fileInfo.id,
                            scope.row.formFile.fileInfo.fileRealName
                          )
                        "
                        >下載</el-button
                      >
                    </div>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="刪除" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.formFile && scope.row.formFile.fileInfo">
                      <el-button
                        size="mini"
                        type="danger"
                        @click="
                          deleteResultForm(
                            scope.row.formID,
                            scope.row.formFile.fileInfo.fileRealName
                          )
                        "
                        >刪除</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="tourGroupNo" label="團號" width="200" align="center">
          </el-table-column>

          <el-table-column align="center" label="團名" width="450">
            <template slot-scope="{ row }">
              <span>{{ row.travelName }}</span>
              <div>
                <el-tag style="font-size: 14px">
                  出發
                  <span style="color: red">{{ `${row.beginDate} ${row.beginTime}` }}</span>
                  - 回程
                  <span style="color: red">{{ `${row.endDate} ${row.endTime}` }}</span>
                </el-tag>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="團名">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <el-tag>
                出發{{ `${row.beginDate} ${row.beginTime}` }} - 回程{{
                  `${row.endDate} ${row.endTime}`
                }}
              </el-tag>
            </div>
          </template>
        </el-table-column> -->

          <el-table-column align="center" label="數量" width="60">
            <template slot-scope="{ row }">
              <el-tag
                @click="toogleExpand(row)"
                style="font-size: 20px; font-weight: bold; cursor: pointer"
                type="success"
                >{{ row.travelResultCommonForms.length }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="答題統計" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="getAlbum(scope.row.id)"
              >答題統計</el-button
            >
          </template>
        </el-table-column> -->
        </el-table>
      </div>

      <pagination
        v-show="total > 0"
        layout="prev, pager, next"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getAgencyTravelsAndOtherInformation"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { saveCouponCategory } from '@/api/coupon'
import { MessageBox, Message } from 'element-ui'
import { downloadAs } from '@/utils/funcs'
import { isEmpty } from 'lodash-es'
import { mapGetters } from 'vuex'

import { getAgencyTravelsAndOtherInformation, deleteResultForm } from '@/api/agency'

export default {
  name: 'AgencyResultForms',
  components: {
    Pagination,
    noAuth: () => import('@/views/error-page/401'),
  },
  data() {
    return {
      funcName: '常用表單',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        filterType: 1,
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    await this.getAgencyTravelsAndOtherInformation()
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        filterType: 1,
      }
      await this.getAgencyTravelsAndOtherInformation()
    },
    toogleExpand(row) {
      let $table = this.$refs.formDetailsTable
      $table.toggleRowExpansion(row)
    },
    tableRowClassName({ row, rowIndex }) {
      return 'success-row'
    },
    async getAgencyTravelsAndOtherInformation() {
      if (!this.userInfo.agencyCode) return
      this.listLoading = true
      try {
        let resp = await getAgencyTravelsAndOtherInformation(this.listQuery)
        this.list = resp.data.data
        this.total = resp.data.total
        this.listLoading = false
      } catch (e) {
        console.log(e.message)
      }
    },
    async downloadFile(id, fileName) {
      this.listLoading = true
      await downloadAs(id, fileName)
      this.listLoading = false
    },
    async deleteResultForm(id, fileName) {
      if (!confirm(`確定要刪除【${fileName}】?`)) {
        return
      }
      this.listLoading = true
      try {
        await deleteResultForm({ id })
        await this.refresh()
        Message({
          message: '資料刪除完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-table__expanded-cell,
.el-table__expanded-cell:hover {
  background-color: cornsilk !important;
}

.el-tabs--card {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}

.el-tab-pane {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}

.el-table__expand-icon {
  display: none;
}
</style>
